import { useState, useCallback } from "react"

const useModal = () => {
    const [modal, setModal] = useState({ isVisible: false, title: "", content: "" })

    const showModal = useCallback((title, content) => {
        setModal({ isVisible: true, title, content })
    }, [])

    const hideModal = useCallback(() => {
        setModal((prev) => ({ ...prev, isVisible: false }))
    }, [])

    return {
        modal,
        showModal,
        hideModal,
    }
}

export default useModal
